import type { ReactNode } from 'react';
import styles from './ScreenShell.module.css';

interface Props {
  rail: ReactNode;
  children: ReactNode;
  topBar: ReactNode;
  className?: string;
}

export function ScreenShell({ rail, topBar, children, className }: Props) {
  return (
    <div className={[styles.shell, className].filter(Boolean).join(' ')}>
      {topBar}
      <div className={styles.layout}>
        {rail}
        <main id="main" className={styles.main} tabIndex={-1}>
          <div className={styles.mainInner}>{children}</div>
        </main>
      </div>
    </div>
  );
}
